module.exports = __webpack_public_path__ + "static/media/SINGLE BREASTED 3 BUTTONS.803e194f.svg";